// extracted by mini-css-extract-plugin
export var box = "_26-2";
export var checkboxControl = "_26-0";
export var checkboxRow = "_26-9";
export var checked = "_26-3";
export var descriptionSpacer = "_26-b";
export var disabled = "_26-4";
export var icon = "_26-7";
export var input = "_26-1";
export var labelSpacer = "_26-a";
export var medium = "_26-6";
export var small = "_26-5";
export var text = "_26-8";